// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3OzRm","containerItemsCenter":"Skeleton_containerItemsCenter__3XeKB"};